define('modules/editor/models/activeitemstate',['require','exports','module','backbone'],function(require, exports, module) {
  var Backbone = require("backbone");

  module.exports = Backbone.Model.extend({
    CHANGE_ACTIVE_ITEM: "change:item",
    initialize: function(options) {
      this.on("change:item", this.activateSelected, this);
    },
    activateSelected: function(model, item) {
      var prevSelected = this.previous("item");
      //notify the model it has been selected
      if(item && _.isFunction(item.trigger)) {
        item.trigger("item:selected", true);
      }
      //notify the model it has been unselected
      if (prevSelected && _.isFunction(prevSelected.trigger)){
        prevSelected.trigger("item:selected", false);
      }
    },
    getActiveItem: function(){
      return this.get("item");
    },
    selectItem: function(component){
      this.set("item", component);
    },
    deselect: function(){
      this.unset("item");
    }
  });

});

